'use client'

import React, { useState } from 'react'

import { useModalInquiryContext } from '@/context/ModalInquiryContext'
import ContactForm from "@/components/InquryForm/ContactForm";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useTranslations } from 'next-intl';

const ModalInquiry = ({locale}:{locale:string}) => {
	const { isModalOpen, closeModalInquiry } = useModalInquiryContext();
  const t = useTranslations();

	return (
		<section className="">
			<div className={`modal-wishlist-block !flex !justify-center items-center `} onClick={closeModalInquiry}>
				<div
					className={`modal-wishlist-main !static !w-fit max-md:!w-[calc(100vw-40px)] max-md:!max-w-[480px] max-md:mt-10 max-md:mx-auto !rounded-lg ${isModalOpen ? 'open' : ''}`}
					onClick={(e) => {
						e.stopPropagation()
					}}>

					<div className="relative !overflow-y-auto box-border max-md:max-h-[calc(100vh-80px)]"  >
            			<div className='text-2xl max-md:text-lg text-white font-bold text-center bg-mainColor p-6'>{t('form.RequestAQuote')}</div>
						<ContactForm locale={locale} className="!p-6 max-md:!p-4"></ContactForm>
						<button
							type="button"
							aria-label="Close modal"
							className="absolute right-5 top-5 max-md:right-3 max-md:top-3 cursor-pointer z-10"
							onClick={closeModalInquiry}
						>
							<CloseCircleOutlined className="text-xl max-md:text-lg !text-white hover:text-main" aria-hidden="true" />
						</button>
					</div>
				</div>
			</div>
		</section>
	)
}

export default ModalInquiry
